export { StackTrace, BrowserError } from './types'
export { computeStackTrace } from './computeStackTrace'
export { startUnhandledErrorCollection } from './tracekit'



// WEBPACK FOOTER //
// ./node_modules/@datadog/browser-core/src/domain/tracekit/index.ts